import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { DataContext, useAuth, useUser } from "../../context/contextAPI";
import {
  IoAdd,
  IoCheckmarkCircleOutline,
  IoRemove,
  IoTrashOutline,
} from "react-icons/io5";
import { Link } from "react-router-dom";
import StripeWrapper from "../../components/StripeWrapper";
import PaymentForm from "../../components/PayementForm";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const getDate = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${month}/${date}/${year}`;
};

function Cart() {
  const { cart, increase, reduction, removeProduct, total, getTotal } =
    useContext(DataContext);
  const { isAuthenticated } = useAuth();
  const { user } = useUser();
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [step, setStep] = useState(1);
  const [methodPayment, setMethodPayment] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [error, setError] = useState("");
  const [discount, setDiscount] = useState(0);

  const handlePromoCodeChange = (e) => {
    setPromoCode(e.target.value);
  };

  const handleCheckPromoCode = async () => {
    try {
      const q = query(collection(db, "Users"), where("code", "==", promoCode));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError("Code promo invalide ou expiré.");
      } else {
        const userDoc = querySnapshot.docs[0].data();
        const currentDate = new Date();

        if (userDoc.expireDate && userDoc.expireDate.toDate() < currentDate) {
          setError("Code promo expiré.");
        } else {
          setDiscount(10); // Exemple : 10% de réduction
          setError("");
        }
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du code promo: ", error);
      setError("Une erreur s'est produite. Veuillez réessayer.");
    }
  };

  let disableVerif;
  if (isAuthenticated) {
    disableVerif =
      fname === "" ||
      lname === "" ||
      address === "" ||
      city === "" ||
      postal === "" ||
      country === "" ||
      phone === "" ||
      email === "" ||
      methodPayment === "";
  } else {
    disableVerif =
      fname === "" ||
      lname === "" ||
      address === "" ||
      city === "" ||
      postal === "" ||
      country === "" ||
      phone === "" ||
      email === "" ||
      password === "" ||
      confirmPassword === "" ||
      methodPayment === "";
  }

  const [msgPwd, setMsgPwd] = useState(false);

  const handleRetour = () => {
    setStep(step - 1);
  };
  const handleSuivant = () => {
    setStep(step + 1);
  };

  const handlePwd = (e) => {
    setPassword(e.target.value);
  };

  useEffect(() => {
    if (user) {
      setFname(user.firstName);
      setLname(user.lastName);
      setAddress(user.address);
      setCity(user.city);
      setPostal(user.postal);
      setCountry(user.country);
      setPhone(user.phone);
      setEmail(user.email);
    }

    getTotal();
  }, [user, getTotal]);

  return (
    <>
      <Helmet>
        <title>Panier</title>
      </Helmet>

      <div className="bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100">
        {step === 1 ? (
          <div className="px-5 md:px-8 lg:px-32 xl:px-40 2xl:px-60 py-16">
            <h2 className="mt-10 text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
              Votre panier
            </h2>

            <section class="relative mt-5">
              <div class="w-full max-w-7xl px-3 lg-6 space-y-2 mx-auto">
                <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead class="text-gray-700 poppins-bold uppercase bg-pink-300">
                      <tr>
                        <th scope="col" class="px-16 py-3 text-center">
                          Image
                        </th>
                        <th scope="col" class="px-6 py-3">
                          Produit
                        </th>
                        <th scope="col" class="px-6 py-3 text-center">
                          Quantité
                        </th>
                        <th scope="col" class="px-6 py-3">
                          Prix
                        </th>
                        <th scope="col" class="px-6 py-3 text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {cart.length === 0 ? (
                        <tr class="bg-white border-b hover:bg-gray-50">
                          <td
                            colSpan={5}
                            className="text-center py-3 poppins-semibold uppercase"
                          >
                            Aucun produit ajouté
                          </td>
                        </tr>
                      ) : (
                        cart.map((item) => (
                          <tr
                            class="bg-white border-b hover:bg-gray-50"
                            key={item._id}
                          >
                            <td class="p-4 flex items-center justify-center">
                              <img
                                src={item.imgSrc}
                                class="w-16 md:w-24 max-w-full max-h-full"
                                alt={item.imgAlt}
                              />
                            </td>
                            <td class="px-6 py-4 poppins-semibold text-gray-900 uppercase">
                              {item.title}
                            </td>
                            <td class="px-6 py-4">
                              <div class="flex items-center justify-center">
                                <button
                                  class={`inline-flex items-center justify-center p-1 me-3 text-sm font-medium h-6 w-6 text-white border-gray-300 rounded-full focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 ${
                                    item.count <= 1
                                      ? "cursor-not-allowed bg-gray-400 hover:bg-gray-400"
                                      : "hover:bg-pink-600 bg-black"
                                  }`}
                                  type="button"
                                  onClick={() => reduction(item._id)}
                                  disabled={item.count <= 1}
                                >
                                  <IoRemove size={20} color="#fff" />
                                </button>
                                <div>
                                  <input
                                    type="number"
                                    id="first_product"
                                    class="bg-gray-50 w-20 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block px-2.5 py-1"
                                    value={item.count}
                                    placeholder="1"
                                    required
                                  />
                                </div>
                                <button
                                  class="inline-flex items-center justify-center h-6 w-6 p-1 ms-3 text-sm font-medium text-white bg-black border border-gray-300 rounded-full focus:outline-none hover:bg-pink-600 focus:ring-4 focus:ring-gray-200"
                                  type="button"
                                  onClick={() => increase(item._id)}
                                >
                                  <IoAdd size={20} color="#fff" />
                                </button>
                              </div>
                            </td>
                            <td class="px-6 py-4 poppins-semibold text-gray-900">
                              {((item.prix * 90) / 100).toFixed(2) * item.count}{" "}
                              RU
                            </td>
                            <td class="px-6 py-4">
                              <button
                                class="text-red-600 hover:underline flex mx-auto"
                                onClick={() => removeProduct(item._id)}
                              >
                                <IoTrashOutline size={18} className="me-1" />{" "}
                                <span>Effacer</span>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            {cart.length > 0 && (
              <div class="flex items-center flex-col sm:flex-row justify-between gap-3 mt-4 px-4 md:px-5">
                <p class="rounded-full py-1.5 poppins-semibold flex items-center text-lg text-black justify-center">
                  <span>Sous-total</span>: {total} RU
                </p>

                <button
                  type="button"
                  onClick={handleSuivant}
                  class="px-5 py-1.5 sm:py-2 rounded-full text-white text-sm tracking-wider poppins-bold outline-none bg-black hover:bg-pink-600"
                >
                  Passer à la paiement
                </button>
              </div>
            )}
          </div>
        ) : step === 2 ? (
          <div className="px-5 md:px-8 lg:px-32 xl:px-40 2xl:px-60 py-16">
            <h2 className="mt-10 text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
              Compléter votre informations
            </h2>

            <section class="relative mt-5">
              <div class="w-full max-w-7xl px-3 lg-6 mx-auto">
                <div className="mb-6 space-y-2">
                  <h3 className="poppins-bold text-xl text-black underline">
                    Informations sur la livraison
                  </h3>
                  {isAuthenticated ? (
                    <div class="mx-auto w-full h-max rounded-md sticky top-0">
                      {user && (
                        <div>
                          <div>
                            <h3 class="text-base poppins-semibold text-gray-800 mb-3">
                              Détails personnels
                            </h3>
                            <div class="grid md:grid-cols-2 gap-4">
                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre nom"
                                  value={fname}
                                  onChange={(e) => {
                                    setFname(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre prénom"
                                  value={lname}
                                  onChange={(e) => {
                                    setLname(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="email"
                                  placeholder="Votre adresse e-mail"
                                  value={email}
                                  onChange={(e) => {
                                    setEmail(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre N° téléphone"
                                  value={phone}
                                  onChange={(e) => {
                                    setPhone(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="mt-8">
                            <h3 class="text-base poppins-semibold text-gray-800 mb-3">
                              Adresse de livraison
                            </h3>
                            <div class="grid md:grid-cols-2 gap-4">
                              <input
                                type="text"
                                value={address}
                                onChange={(e) => {
                                  setAddress(e.target.value);
                                }}
                                placeholder="Votre adresse"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={city}
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                                placeholder="Votre ville"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={postal}
                                onChange={(e) => {
                                  setPostal(e.target.value);
                                }}
                                placeholder="Votre code postal"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={country}
                                onChange={(e) => {
                                  setCountry(e.target.value);
                                }}
                                placeholder="Votre pays"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <p className="text-gray-900 text-sm">
                        Vous avez déjà un compte?{" "}
                        <Link
                          to="/auth/connexion?checkout=true"
                          className="text-blue-600 hover:underline hover:text-blue-700"
                        >
                          Se connecter
                        </Link>
                      </p>
                      <div class="w-full h-max rounded-md sticky top-0 mt-3">
                        <div>
                          <div>
                            <h3 class="text-base poppins-semibold text-gray-800 mb-3">
                              Détails personnels
                            </h3>
                            <div class="grid md:grid-cols-2 gap-4">
                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre nom"
                                  value={fname}
                                  onChange={(e) => {
                                    setFname(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre prénom"
                                  value={lname}
                                  onChange={(e) => {
                                    setLname(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="email"
                                  placeholder="Votre adresse e-mail"
                                  value={email}
                                  onChange={(e) => {
                                    setEmail(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="text"
                                  placeholder="Votre N° téléphone"
                                  value={phone}
                                  onChange={(e) => {
                                    setPhone(e.target.value);
                                  }}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>

                              <div class="relative flex items-center">
                                <input
                                  type="password"
                                  placeholder="Votre mot de passe"
                                  value={password}
                                  onChange={handlePwd}
                                  class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="mt-8">
                            <h3 class="text-base poppins-semibold text-gray-800 mb-3">
                              Adresse de livraison
                            </h3>
                            <div class="grid md:grid-cols-2 gap-4">
                              <input
                                type="text"
                                value={address}
                                onChange={(e) => {
                                  setAddress(e.target.value);
                                }}
                                placeholder="Votre adresse"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={city}
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                                placeholder="Votre ville"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={postal}
                                onChange={(e) => {
                                  setPostal(e.target.value);
                                }}
                                placeholder="Votre code postal"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                              <input
                                type="text"
                                value={country}
                                onChange={(e) => {
                                  setCountry(e.target.value);
                                }}
                                placeholder="Votre pays"
                                class="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-400 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div class="flex items-center mt-3">
                          <input
                            id="register"
                            type="checkbox"
                            class="hidden peer"
                          />
                          <label
                            for="register"
                            class="relative text-sm h-5 w-5 flex items-center justify-center p-1 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white cursor-pointer bg-pink-500 border rounded-full overflow-hidden"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="w-full fill-white"
                              viewBox="0 0 520 520"
                            >
                              <path
                                d="M79.423 240.755a47.529 47.529 0 0 0-36.737 77.522l120.73 147.894a43.136 43.136 0 0 0 36.066 16.009c14.654-.787 27.884-8.626 36.319-21.515L486.588 56.773a6.13 6.13 0 0 1 .128-.2c2.353-3.613 1.59-10.773-3.267-15.271a13.321 13.321 0 0 0-19.362 1.343q-.135.166-.278.327L210.887 328.736a10.961 10.961 0 0 1-15.585.843l-83.94-76.386a47.319 47.319 0 0 0-31.939-12.438z"
                                data-name="7-Check"
                                data-original="#000000"
                              />
                            </svg>
                          </label>
                          <p class="text-black ml-3">
                            Créer un compte avec les informations ci-dessus ?
                          </p>
                        </div> */}
                      </div>
                    </>
                  )}
                </div>

                <div className="mb-6 space-y-2">
                  <h3 className="poppins-bold text-xl text-black underline">
                    Mode de livraison
                  </h3>
                  <div class="flex items-center">
                    <input
                      id="checkbox3"
                      type="checkbox"
                      class="hidden peer"
                      checked
                      disabled
                    />
                    <label
                      for="checkbox3"
                      class="relative flex items-center justify-center p-1 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-6 h-6 cursor-pointer bg-pink-500 border rounded-full overflow-hidden"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-full fill-white"
                        viewBox="0 0 520 520"
                      >
                        <path
                          d="M79.423 240.755a47.529 47.529 0 0 0-36.737 77.522l120.73 147.894a43.136 43.136 0 0 0 36.066 16.009c14.654-.787 27.884-8.626 36.319-21.515L486.588 56.773a6.13 6.13 0 0 1 .128-.2c2.353-3.613 1.59-10.773-3.267-15.271a13.321 13.321 0 0 0-19.362 1.343q-.135.166-.278.327L210.887 328.736a10.961 10.961 0 0 1-15.585.843l-83.94-76.386a47.319 47.319 0 0 0-31.939-12.438z"
                          data-name="7-Check"
                          data-original="#000000"
                        />
                      </svg>
                    </label>
                    <p class="text-black ml-4">
                      Livraison gratuite -{" "}
                      <span className="poppins-semibold">
                        Livraison gratuite
                      </span>
                    </p>
                  </div>
                </div>
                
                <div className="mb-6 space-y-2">
                  <h3 className="poppins-bold text-xl text-black underline">
                    Garantie des produits
                  </h3>
                  <div class="flex items-center">
                    <input
                      id="checkbox3"
                      type="checkbox"
                      class="hidden peer"
                      checked
                      disabled
                    />
                    <label
                      for="checkbox3"
                      class="relative flex items-center justify-center p-1 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-6 h-6 cursor-pointer bg-pink-500 border rounded-full overflow-hidden"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-full fill-white"
                        viewBox="0 0 520 520"
                      >
                        <path
                          d="M79.423 240.755a47.529 47.529 0 0 0-36.737 77.522l120.73 147.894a43.136 43.136 0 0 0 36.066 16.009c14.654-.787 27.884-8.626 36.319-21.515L486.588 56.773a6.13 6.13 0 0 1 .128-.2c2.353-3.613 1.59-10.773-3.267-15.271a13.321 13.321 0 0 0-19.362 1.343q-.135.166-.278.327L210.887 328.736a10.961 10.961 0 0 1-15.585.843l-83.94-76.386a47.319 47.319 0 0 0-31.939-12.438z"
                          data-name="7-Check"
                          data-original="#000000"
                        />
                      </svg>
                    </label>
                    <p class="text-black ml-4">
                      Nous sommes fiers de la qualité de nos produits et <span className="poppins-semibold">offrons une garantie d'un an</span> pour assurer votre satisfaction et tranquillité d'esprit.
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  <h3 className="poppins-bold text-xl text-black underline">
                    Mode de paiement
                  </h3>
                  <ul class="text-sm text-gray-900 bg-transparent border border-gray-400 rounded-lg">
                    <li class="w-full border-b border-gray-400 rounded-t-lg bg-transparent">
                      <div className="flex items-center px-4 py-2">
                        <input
                          type="radio"
                          name="payment_mode"
                          className="radio border border-gray-400 checked:bg-pink-500 w-5 h-5"
                          id="carte"
                          onChange={() => setMethodPayment("Stripe")}
                        />
                        <label for="carte" class="text-sm text-black ml-4">
                          Payez en ligne via Stripe (international et national){" "}
                          {methodPayment === "Stripe" && (
                            <>
                              <br />
                              <span>
                                Vous serez redirigé vers Stripe pour finaliser
                                le paiement. (Carte de débit/Carte de
                                crédit/Banque en ligne)
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    </li>
                    <li class="w-full border-b border-gray-200 rounded-b-lg">
                      <div className="flex items-center px-4 py-2">
                        <input
                          type="radio"
                          name="payment_mode"
                          className="radio border border-gray-400 checked:bg-pink-500 w-5 h-5"
                          id="virement"
                          onChange={() => setMethodPayment("Virement")}
                        />
                        <label for="virement" class="text-sm text-black ml-4">
                          Virement bancaire
                          {methodPayment === "Virement" && (
                            <>
                              <br />
                              <span>
                                Veuillez envoyer de l'argent sur notre compte
                                bancaire:{" "}
                                <span className="poppins-semibold">
                                  00009 - 05042 24550580005 23
                                </span>
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <div class="flex gap-4 max-md:flex-col mt-8">
              <button
                type="button"
                onClick={handleRetour}
                class="rounded-md px-4 py-2 w-full poppins-semibold bg-transparent transition-all duration-300 border-gray-400 hover:bg-gray-400 border-2 text-gray-800 max-md:order-1"
              >
                Retour
              </button>
              <button
                type="button"
                onClick={handleSuivant}
                // disabled={disableVerif}
                class={`rounded-md px-4 py-2 w-full poppins-semibold  text-white transition-all duration-300 ${
                  disableVerif
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gray-800 hover:bg-pink-600"
                }`}
              >
                Vérifier
              </button>
            </div>
          </div>
        ) : (
          <div className="px-5 md:px-8 lg:px-32 xl:px-40 2xl:px-60 py-16">
            <div class="md:max-w-5xl max-w-xl mx-auto mt-14">
              <div class="grid md:grid-cols-2 lg:grid-cols-3">
                <div class="lg:col-span-2 max-md:order-1 bg-gray-50 px-6 py-4">
                  <h2 class="text-3xl poppins-bold text-gray-800 text-center">
                    Effectuer un paiement
                  </h2>
                  <p class="text-gray-800 text-sm mt-4">
                    Terminez votre transaction rapidement et en toute sécurité
                    grâce à notre processus de paiement facile à utiliser.
                  </p>

                  <StripeWrapper>
                    <div className="px-2">
                      <PaymentForm
                        total={total}
                        cartItems={cart}
                        fName={fname}
                        lName={lname}
                        address={address}
                        city={city}
                        postal={postal}
                        country={country}
                        phone={phone}
                        email={email}
                        pwd={password}
                        methodPayment={methodPayment}
                      />
                    </div>
                  </StripeWrapper>
                  <button
                    type="boutton"
                    className="w-full flex cursor-pointer justify-center py-1 px-4 border border-transparent poppins-semibold rounded-md text-blue-500 hover:text-blue-600 focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out mt-2"
                    onClick={handleRetour}
                  >
                    Revenir en arrière
                  </button>
                </div>

                <div class="bg-gray-300 p-6 rounded-r-md">
                  <h2 class="text-3xl poppins-bold text-gray-800">
                    {total} MUR
                  </h2>
                  {cart.length > 0 && (
                    <ul class="text-gray-800 mt-6 space-y-3">
                      {cart.map((item) => (
                        <li class="flex flex-wrap gap-4 text-sm" key={item._id}>
                          {item.title} ({item.count}){" "}
                          <span class="ml-auto poppins-bold">
                            {((item.prix * 90) / 100).toFixed(2) * item.count}{" "}
                            MUR
                          </span>
                        </li>
                      ))}
                      <li class="flex flex-wrap gap-4 text-sm">
                        Tax <span class="ml-auto poppins-bold">0 MUR</span>
                      </li>
                      <li class="flex flex-wrap gap-4 text-sm poppins-bold border-t-2 pt-4">
                        Total <span class="ml-auto">{total} MUR</span>
                      </li>
                    </ul>
                  )}

                  <div class="relative w-full mt-5">
                    <input
                      type="text"
                      class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg border-s-gray-50 border-s-2 border border-gray-300 outline-none focus:box-border focus:border-pink-600"
                      placeholder="Code promo"
                      value={promoCode}
                      onChange={handlePromoCodeChange}
                      required
                    />
                    <button
                      type="button"
                      class="absolute top-0 end-0 h-full p-2 text-sm text-white bg-black rounded-e-lg hover:bg-pink-600 focus:ring-4 focus:outline-none"
                      onClick={handleCheckPromoCode}
                    >
                      <IoCheckmarkCircleOutline size={25} />
                    </button>
                  </div>
                  {error && <p className="text-red-500 mt-0.5 text-xs">{error}</p>}
                  {discount > 0 && <p className="text-green-500 mt-2 text-xs">Réduction de {discount}% appliquée!</p>}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Cart;
